export default __webpack_public_path__ + "static/char-s-49-ja-f96c446340dda8aa44bf1df2f10a0930.webp";